import numeral from 'numeral'

var decimal = {
    base: 1000,
    suffixes: ['B', 'KB', 'MB', 'GB'],
  },
  binary = {
    base: 1024,
    suffixes: ['B', 'KiB', 'MiB', 'GiB'],
  }

var allSuffixes = decimal.suffixes.concat(
  binary.suffixes.filter(function (item) {
    return decimal.suffixes.indexOf(item) < 0
  }),
)
var unformatRegex = allSuffixes.join('|')
// Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')'

numeral.register('format', 'bytes-capped', {
  regexps: {
    format: /([0\s]i?gb)/,
    unformat: new RegExp(unformatRegex),
  },
  format: function (value, format, roundingFunction) {
    var output,
      bytes = format.includes('igb') ? binary : decimal,
      suffix =
        format.includes(' gb') || format.includes(' igb')
          ? ' '
          : '',
      power,
      min,
      max

    // check for space before
    format = format.replace(/\s?i?g?b/, '')

    for (power = 0; power <= bytes.suffixes.length; power++) {
      min = Math.pow(bytes.base, power)
      max = Math.pow(bytes.base, power + 1)

      if (power === bytes.suffixes.length - 1) {
        max = Number.MAX_SAFE_INTEGER
      }

      if (value === null || value === 0 || (value >= min && value < max)) {
        suffix += bytes.suffixes[power]

        if (min > 0) {
          value = value / min
        }

        break
      }
    }

    output = numeral._.numberToFormat(value, format, roundingFunction)

    return output + suffix
  },
  unformat: function (string) {
    var value = numeral._.stringToNumber(string),
      power,
      bytesMultiplier

    if (value) {
      for (power = decimal.suffixes.length - 1; power >= 0; power--) {
        if (string.includes(decimal.suffixes[power])) {
          bytesMultiplier = Math.pow(decimal.base, power)

          break
        }

        if (string.includes(binary.suffixes[power])) {
          bytesMultiplier = Math.pow(binary.base, power)

          break
        }
      }

      value *= bytesMultiplier || 1
    }
    return value
  },
})